import axiosInstance from './api';

// Auth API
export const authAPI = {
  login: async (credentials) => {
    const response = await axiosInstance.post('/api/auth/login', credentials);
    return response.data;
  },
  
  register: async (userData) => {
    const response = await axiosInstance.post('/api/auth/register', userData);
    return response.data;
  },
  
  getMe: async () => {
    const response = await axiosInstance.get('/api/auth/me');
    return response.data;
  }
};

// Categories API
export const categoriesAPI = {
  getAll: async () => {
    const response = await axiosInstance.get('/api/categories');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axiosInstance.get(`/api/categories/${id}`);
    return response.data;
  },
  
  create: async (categoryData) => {
    const response = await axiosInstance.post('/api/categories', categoryData);
    return response.data;
  },
  
  update: async (id, categoryData) => {
    const response = await axiosInstance.put(`/api/categories/${id}`, categoryData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/categories/${id}`);
    return response.data;
  }
};

// Events API
export const eventsAPI = {
  getAll: async () => {
    const response = await axiosInstance.get('/api/events');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axiosInstance.get(`/api/events/${id}`);
    return response.data;
  },
  
  create: async (eventData) => {
    const response = await axiosInstance.post('/api/events', eventData);
    return response.data;
  },
  
  update: async (id, eventData) => {
    const response = await axiosInstance.put(`/api/events/${id}`, eventData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/events/${id}`);
    return response.data;
  },
  
  getCertificates: async (id) => {
    const response = await axiosInstance.get(`/api/events/${id}/certificates`);
    return response.data;
  }
};

// Certificates API
export const certificatesAPI = {
  // Public routes
  verify: async (certificateId) => {
    const response = await axiosInstance.get(`/api/certificates/verify/${certificateId}`);
    return response.data;
  },
  
  // User routes
  getMyCertificates: async () => {
    const response = await axiosInstance.get('/api/certificates/my-certificates');
    return response.data;
  },
  
  // Admin routes
  getAll: async () => {
    const response = await axiosInstance.get('/api/certificates/admin');
    return response.data;
  },
  
  getByCategory: async (categoryId) => {
    const response = await axiosInstance.get(`/api/certificates/category/${categoryId}`);
    return response.data;
  },
  
  uploadTemplate: async (templateFile) => {
    const formData = new FormData();
    formData.append('template', templateFile);
    
    const response = await axiosInstance.post('/api/certificates/admin/templates', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  
  generateBulk: async (csvFile, templateFile, mappingFile = null, eventId, positioningMethod = 'auto_detect') => {
    const formData = new FormData();
    formData.append('csv', csvFile);
    formData.append('template', templateFile);
    if (mappingFile) {
      formData.append('mapping', mappingFile);
    }
    if (eventId) {
      formData.append('eventId', eventId);
    }
    if (positioningMethod) {
      formData.append('positioning_method', positioningMethod);
    }
    
    const response = await axiosInstance.post('/api/certificates/admin/generate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  
  generateSingle: async (certificateData) => {
    const response = await axiosInstance.post('/api/certificates/admin/generate-single', certificateData);
    return response.data;
  },
  
  update: async (id, certificateData, imageFile = null) => {
    const formData = new FormData();
    
    // Append all certificate data
    Object.keys(certificateData).forEach(key => {
      formData.append(key, certificateData[key]);
    });
    
    if (imageFile) {
      formData.append('image', imageFile);
    }
    
    const response = await axiosInstance.put(`/api/certificates/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/certificates/${id}`);
    return response.data;
  }
};

// Email API
export const emailAPI = {
  sendCertificateEmail: async (certificateId) => {
    const response = await axiosInstance.post(`/api/emails/send/${certificateId}`);
    return response.data;
  },
  
  sendBulkEmails: async (emailData) => {
    const response = await axiosInstance.post('/api/emails/bulk', emailData);
    return response.data;
  },
  
  getEmailStatus: async () => {
    const response = await axiosInstance.get('/api/emails/status');
    return response.data;
  }
};

// Helper function to set auth token
export const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
    localStorage.setItem('access_token', token);
  } else {
    delete axiosInstance.defaults.headers.Authorization;
    localStorage.removeItem('access_token');
  }
};

// Helper function to get auth token
export const getAuthToken = () => {
  return localStorage.getItem('access_token');
};

export default {
  auth: authAPI,
  categories: categoriesAPI,
  events: eventsAPI,
  certificates: certificatesAPI,
  email: emailAPI,
  setAuthToken,
  getAuthToken,
};
